import { getRNAppBundleVersion } from "./LoggableDeviceProperties";

/**
 * Enriches context with rnBundleVersion for all Datadog logs.
 */
export const enrichContext = (context?: Record<string, unknown>): Record<string, unknown> => {
  const rnBundleVersion = getRNAppBundleVersion();
  return { ...context, rnBundleVersion };
};
